import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=63b54781&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b54781')) {
      api.createRecord('63b54781', component.options)
    } else {
      api.reload('63b54781', component.options)
    }
    module.hot.accept("./ErrorComponent.vue?vue&type=template&id=63b54781&", function () {
      api.rerender('63b54781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/ErrorComponent.vue"
export default component.exports